export const ACTIVE_IDS_CLEAR_ADVANCE_ID = 'active_ids_clear_advance_id';
export const ACTIVE_IDS_CLEAR_IDS = 'active_ids_clear_ids';
export const ACTIVE_IDS_CLEAR_FORGIVENESS_ID = 'active_ids_clear_forgiveness_id';
export const ACTIVE_IDS_CLEAR_OPPORTUNITY_ID = 'active_ids_clear_opportunity_id';
export const ACTIVE_IDS_CLEAR_STIPULATION_ID = 'active_ids_clear_stipulation_id';
export const ACTIVE_IDS_SET_ADVANCE_ID = 'active_ids_set_advance_id';
export const ACTIVE_IDS_SET_FORGIVENESS_ID = 'active_ids_set_forgiveness_id';
export const ACTIVE_IDS_SET_OPPORTUNITY_ID = 'active_ids_set_opportunity_id';
export const ACTIVE_IDS_SET_STIPULATION_ID = 'active_ids_set_stipulation_id';
